<div mat-dialog-title class="modal-header">
  <div class="css-infwte">
    <h2 class="css-1ihths2">Detail</h2>
  </div>

  <button mat-icon-button mat-dialog-close aria-label="Close">
    <mat-icon>close</mat-icon>
  </button>
</div>

<div class="modal-content">

  <div class="css-1cj4irw">
    <div class="css-s2efhj2"><h4 class="css-o2z3hy">Labellisation(s)</h4>
    </div>
    <hr>
    <div class="css-s2efhj2">
      <p class="css-1bgqvne" *ngFor="let certification of product.certifications">{{certification}}</p>
    </div>
  </div>


</div>

<div mat-dialog-actions class="modal-footer" style="margin-bottom: 0 !important;">
  <button type="button" class="btn-transparent" mat-dialog-close style="margin-right: 20px;">Fermer</button>

</div>
